import { render, staticRenderFns } from "./InputField.vue?vue&type=template&id=2ba17246&scoped=true&"
import script from "./InputField.vue?vue&type=script&lang=js&"
export * from "./InputField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba17246",
  null
  
)

export default component.exports